export const importantDays = [
  {
    id: 1,
    month: "April - 2021",
    list: [
      {
        id: 1,
        name: "5th - Hostel Re-open",
      },
      {
        id: 2,
        name: "6th - School Re-open",
      },
      {
        id: 3,
        name: "10th - Guardian Meeting",
      },
      {
        id: 4,
        name: "12th - Eligibililty Test for Class - X (Candidate)",
      },
      {
        id: 5,
        name: "24th - Farewell for Candidate",
      },
    ],
  },
  {
    id: 2,
    month: "May - 2021",
    list: [
      {
        id: 1,
        name: "3rd to 13th - P.A - 1(Periodic Assessment) Class - I to IX",
      },
      {
        id: 2,
        name: "14th to 31st - Summer Vacation",
      },
    ],
  },
  {
    id: 3,
    month: "June - 2021",
    list: [
      {
        id: 1,
        name: "1st - Hostel Re-open",
      },
      {
        id: 2,
        name: "2nd - School Re-open",
      },
    ],
  },
  {
    id: 4,
    month: "July - 2021",
    list: [
      {
        id: 1,
        name: "15th to 22nd - PA - 2 (Class - I to IX)",
      },
    ],
  },
  {
    id: 5,
    month: "August - 2021",
    list: [
      {
        id: 1,
        name: "15th - Independence Day",
      },
      {
        id: 2,
        name: "20th - 33rd School Establishment Day",
      },
      {
        id: 3,
        name: "24th to 31st - 33rd Selection Test for Class - X",
      },
    ],
  },
  {
    id: 6,
    month: "September - 2021",
    list: [
      {
        id: 1,
        name: "5th - Teacher's Day",
      },
      {
        id: 2,
        name: "14th to 25th - Half- Yearly Examination (Class - PP to IX)",
      },
    ],
  },
  {
    id: 7,
    month: "November - 2021",
    list: [
      {
        id: 1,
        name: "14th - Children's Day",
      },
      {
        id: 2,
        name: "15th to 23rd - PA - 3 (Class - I to IX)",
      },
      {
        id: 3,
        name: "27th - Sport Day(Final)",
      },
    ],
  },
  {
    id: 8,
    month: "December - 2021",
    list: [
      {
        id: 1,
        name: "22nd to 3rd - 2022 Christmas Vacation",
      },
    ],
  },
  {
    id: 9,
    month: "January - 2022",
    list: [
      {
        id: 1,
        name: "10th to 19th - PA - 4 (Class - I to IX)",
      },
      {
        id: 2,
        name: "21st - School Picnic",
      },
      {
        id: 3,
        name: "26th - Republic Day",
      },
    ],
  },
  {
    id: 10,
    month: "March - 2022",
    list: [
      {
        id: 1,
        name: "7th to 8th -Annual Examination(Class - PP to IX)",
      },
      {
        id: 2,
        name: "28th - Declaration of Annual Result",
      },
    ],
  },
];

export const holidaysDays = [
  {
    id: 1,
    month: "April - 2021",
    list: [
      {
        id: 1,
        name: "2nd - Good Friday",
      },
      {
        id: 2,
        name: "4th - Ester Sunday",
      },
      {
        id: 3,
        name: "15th - Bengali New Year",
      },
      {
        id: 4,
        name: "21st - Garia Puja ",
      },
    ],
  },
  {
    id: 2,
    month: "May - 2021",
    list: [
      {
        id: 1,
        name: "1st - International Labour Day",
      },
      {
        id: 2,
        name: "14th - Id-Ul-Fitr",
      },
      {
        id: 3,
        name: "29th - Buddha Purninma",
      },
    ],
  },
  {
    id: 3,
    month: "July - 2021",
    list: [
      {
        id: 1,
        name: "17th - Kharchi Puja",
      },
      {
        id: 2,
        name: "21st - Id-Ul Zuha(Bakrid)",
      },
      {
        id: 3,
        name: "31st - Ker-Puja",
      },
    ],
  },
  {
    id: 4,
    month: "August - 2021",
    list: [
      {
        id: 1,
        name: "19th - Muharam/ Birthday of Maharaja Bir Bikram Kishore Manikya Bahadur Debbarman",
      },
      {
        id: 2,
        name: "30th - Janmashtami",
      },
    ],
  },
  {
    id: 5,
    month: "October - 2021",
    list: [
      {
        id: 1,
        name: "31st - Mahalaya",
      },
    ],
  },
  {
    id: 6,
    month: "November - 2021",
    list: [
      {
        id: 1,
        name: "4th - Diwali",
      },
    ],
  },

  {
    id: 7,
    month: "January - 2022",
    list: [
      {
        id: 1,
        name: "1st - New Year",
      },
    ],
  },
  {
    id: 8,
    month: "March - 2022",
    list: [
      {
        id: 1,
        name: "1st - Sivoratri",
      },
      {
        id: 2,
        name: "19th - Holi",
      },
    ],
  },
];
